<template>
  <div class="home">

    <ProposalCreate />

    <div style="position: absolute;bottom: 0;text-align: center;width:70%">
      当前为免费版, 更多功能请联系 <a href="https://t.me/Orangemio">Telegram</a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ProposalCreate from '@/components/ProposalCreate.vue';

export default {
  name: 'Home',
  components: {
    ProposalCreate,

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  padding: 36px;
}
.logo {
  max-width: 200px;
}
</style>
